import type { ApolloClient as ApolloOfflineClient } from '@wora/apollo-offline'
import type ApolloClient from 'apollo-client'
import { info } from '../../util/analytics'

export function removeStoredMutationsById(client: ApolloClient<any>, id: string, options: { before?: number } = {}) {
  // useApolloClient returns normal ApolloClient, but it'll actually be ApolloOfflineClient
  const _client = client as ApolloOfflineClient

  // Not every consumer uses the offline client (e.g. the painter app uses a plain ApolloClient),
  // in which case there's no offline mutation store to clean up. No-op instead of throwing
  // "_client.getStoreOffline is not a function" after an otherwise-successful save.
  if (typeof _client.getStoreOffline !== 'function') {
    return
  }

  const storedMutationIds = _client
    .getStoreOffline()
    .getListMutation()
    .filter((mutation) => {
      const mutationId = mutation?.request?.payload?.context?.__mutation_id__
      if (!mutationId) {
        info('Bad mutation:', JSON.stringify(mutation))
        return false
      }
      const isMatchingId = mutationId === id

      // only removes mutations before the passed in options.before (if provided)
      const isBefore = !options.before || mutation.fetchTime < options.before

      return isMatchingId && isBefore
    })
    .map((mutation) => mutation.id)

  storedMutationIds.forEach((mutationId) => {
    _client.getStoreOffline().remove(mutationId)
  })
}
